export default __webpack_public_path__ + "static/media/fanda_v2.56d3a217.jpg";